import React, { useState, useMemo } from 'react';
import { Link } from 'react-router-dom';
import './Insights.css';
import { insights } from '../data/site';

const categories = ['All', ...Array.from(new Set(insights.map((i) => i.category)))];

const Insights = () => {
  const [active, setActive] = useState('All');
  const [query, setQuery] = useState('');

  const filtered = useMemo(() => {
    return insights.filter((i) => {
      const cat = active === 'All' || i.category === active;
      const q = query.trim().toLowerCase();
      const matches = !q ||
        i.title.toLowerCase().includes(q) ||
        i.excerpt.toLowerCase().includes(q) ||
        (i.tags || []).join(' ').toLowerCase().includes(q);
      return cat && matches;
    });
  }, [active, query]);

  const featured = insights[0];
  const rest = filtered.filter((i) => i.id !== featured.id);

  return (
    <div className="insights-page page-shell">
      <section className="insights-hero section-dark">
        <span className="aurora-orb hero-orb-a" />
        <span className="aurora-orb hero-orb-b" />
        <div className="site-container-wide">
          <span className="section-eyebrow">Insights</span>
          <h1>
            Field-tested thinking for <span className="gradient-text serif-accent">AI &amp; data leaders.</span>
          </h1>
          <p>
            Architecture patterns, operating model playbooks, regulation briefings, and the things we
            wish someone had told us a quarter earlier.
          </p>
          <div className="insights-search">
            <input
              type="search"
              placeholder="Search insights, tags, authors…"
              value={query}
              onChange={(e) => setQuery(e.target.value)}
            />
          </div>
          <div className="insights-tabs">
            {categories.map((c) => (
              <button
                key={c}
                className={c === active ? 'active' : ''}
                onClick={() => setActive(c)}
                type="button"
              >{c}</button>
            ))}
          </div>
        </div>
      </section>

      {active === 'All' && !query && (
        <section className="section featured-insight">
          <div className="site-container-wide featured-insight-grid">
            <Link to={`/insights/${featured.id}`} className="featured-insight-card professional-card">
              <img src={featured.image} alt={featured.title} />
              <div className="featured-body">
                <span className="eyebrow-tag">Featured · {featured.category}</span>
                <h2>{featured.title}</h2>
                <p>{featured.excerpt}</p>
                <div className="insight-meta">
                  <span>{featured.author} · {featured.role}</span>
                  <span>{featured.readTime} · {featured.date}</span>
                </div>
              </div>
            </Link>
          </div>
        </section>
      )}

      <section className="section insights-grid-section">
        <div className="site-container-wide">
          <div className="insights-grid">
            {rest.map((article) => (
              <Link to={`/insights/${article.id}`} className="insight-card professional-card" key={article.id}>
                <img src={article.image} alt={article.title} />
                <div className="insight-body">
                  <span className="eyebrow-tag">{article.category}</span>
                  <h3>{article.title}</h3>
                  <p>{article.excerpt}</p>
                  <div className="insight-meta">
                    <span>{article.author}</span>
                    <span>{article.readTime}</span>
                  </div>
                </div>
              </Link>
            ))}
          </div>

          {rest.length === 0 && (
            <div className="empty-state">
              <h3>No insights match your search.</h3>
              <p>Try a broader filter or search term.</p>
            </div>
          )}
        </div>
      </section>
    </div>
  );
};

export default Insights;
